/* eslint-disable default-param-last */
import initialState from '../../initialState';
import {
  EDIT_BOOK,
  SHOW_ALL_BOOKS,
  SHOW_FEATURED_BOOKS,
  UPDATE_EDIT_INFO,
  UPDATE_SEARCH_TEXT
} from './actionTypes';

const statusReducer = (state = initialState.status, action) => {
  switch (action.type) {
    case SHOW_FEATURED_BOOKS:
      return { ...state, filterFeature: action.payload };
    case SHOW_ALL_BOOKS:
      return { ...state, filterFeature: action.payload };
    case EDIT_BOOK:
      return {
        ...state,
        ...action.payload,
      };
    case UPDATE_EDIT_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case UPDATE_SEARCH_TEXT:
      return {
        ...state,
        searchText: action.payload,
      };
    default:
      return state;
  }
};
export default statusReducer;
